// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dFulfillmentMethod from "../Restaumatic.Menu.V2.Types.FulfillmentMethod/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dOrderOrigin from "../Restaumatic.Menu.V2.Types.OrderOrigin/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dPaymentMethod from "../Restaumatic.Menu.V2.Types.PaymentMethod/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $InternalParameterChoiceId = (tag, _1) => ({tag, _1});
const OriginChoiceIsSymbol = {reflectSymbol: () => "OriginChoice"};
const FulfillmentMethodChoiceIsSymbol = {reflectSymbol: () => "FulfillmentMethodChoice"};
const PaymentMethodChoiceIsSymbol = {reflectSymbol: () => "PaymentMethodChoice"};
const IsDividedChoiceIsSymbol = {reflectSymbol: () => "IsDividedChoice"};
const ScheduleChoiceIsSymbol = {reflectSymbol: () => "ScheduleChoice"};
const decodeSingleConstructorAr1 = {unsafeDecodeSingleConstructorArgument: x => Unscramble.decodeBoolean(x.contents)};
const genericEncodeArgsArgument = {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)};
const genericDecodeArgsArgument = {
  decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign$dGeneric$dClass.booleanDecode.decode}),
  decodeSingleRecordArg: Data$dMaybe.Nothing
};
const OriginChoice = value0 => $InternalParameterChoiceId("OriginChoice", value0);
const FulfillmentMethodChoice = value0 => $InternalParameterChoiceId("FulfillmentMethodChoice", value0);
const PaymentMethodChoice = value0 => $InternalParameterChoiceId("PaymentMethodChoice", value0);
const IsDividedChoice = value0 => $InternalParameterChoiceId("IsDividedChoice", value0);
const ScheduleChoice = value0 => $InternalParameterChoiceId("ScheduleChoice", value0);
const toFillFormTypeInternalPar = {fillFormDataType: v => "unknown"};
const eqInternalParameterChoice = {
  eq: x => y => {
    if (x.tag === "OriginChoice") {
      if (y.tag === "OriginChoice") {
        if (x._1.tag === "Online") { return y._1.tag === "Online"; }
        if (x._1.tag === "Phone") { return y._1.tag === "Phone"; }
        if (x._1.tag === "Bar") { return y._1.tag === "Bar"; }
        if (x._1.tag === "Other") { return y._1.tag === "Other"; }
        return false;
      }
      return false;
    }
    if (x.tag === "FulfillmentMethodChoice") {
      if (y.tag === "FulfillmentMethodChoice") {
        if (x._1.tag === "Delivery") { return y._1.tag === "Delivery"; }
        if (x._1.tag === "Takeaway") { return y._1.tag === "Takeaway"; }
        if (x._1.tag === "DineIn") { return y._1.tag === "DineIn"; }
        return false;
      }
      return false;
    }
    if (x.tag === "PaymentMethodChoice") {
      if (y.tag === "PaymentMethodChoice") {
        if (x._1.tag === "PaymentMethodOnline") { return y._1.tag === "PaymentMethodOnline"; }
        if (x._1.tag === "PaymentMethodPrepaid") { return y._1.tag === "PaymentMethodPrepaid"; }
        if (x._1.tag === "PaymentMethodOffline") { return y._1.tag === "PaymentMethodOffline"; }
        return false;
      }
      return false;
    }
    if (x.tag === "IsDividedChoice") {
      if (y.tag === "IsDividedChoice") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "ScheduleChoice") {
      if (y.tag === "ScheduleChoice") { return x._1 === y._1; }
      return false;
    }
    return false;
  }
};
const ordInternalParameterChoic = {
  compare: x => y => {
    if (x.tag === "OriginChoice") {
      if (y.tag === "OriginChoice") { return Restaumatic$dMenu$dV2$dTypes$dOrderOrigin.ordOrderOrigin.compare(x._1)(y._1); }
      return Data$dOrdering.LT;
    }
    if (y.tag === "OriginChoice") { return Data$dOrdering.GT; }
    if (x.tag === "FulfillmentMethodChoice") {
      if (y.tag === "FulfillmentMethodChoice") { return Restaumatic$dMenu$dV2$dTypes$dFulfillmentMethod.ordFulfillmentMethod.compare(x._1)(y._1); }
      return Data$dOrdering.LT;
    }
    if (y.tag === "FulfillmentMethodChoice") { return Data$dOrdering.GT; }
    if (x.tag === "PaymentMethodChoice") {
      if (y.tag === "PaymentMethodChoice") { return Restaumatic$dMenu$dV2$dTypes$dPaymentMethod.ordPaymentMethod.compare(x._1)(y._1); }
      return Data$dOrdering.LT;
    }
    if (y.tag === "PaymentMethodChoice") { return Data$dOrdering.GT; }
    if (x.tag === "IsDividedChoice") {
      if (y.tag === "IsDividedChoice") { return Data$dOrd.ordBoolean.compare(x._1)(y._1); }
      return Data$dOrdering.LT;
    }
    if (y.tag === "IsDividedChoice") { return Data$dOrdering.GT; }
    if (x.tag === "ScheduleChoice") {
      if (y.tag === "ScheduleChoice") { return Data$dOrd.ordBoolean.compare(x._1)(y._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqInternalParameterChoice
};
const genericInternalParameterChoiceId = {
  to: x => {
    if (x.tag === "Inl") { return $InternalParameterChoiceId("OriginChoice", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $InternalParameterChoiceId("FulfillmentMethodChoice", x._1._1); }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $InternalParameterChoiceId("PaymentMethodChoice", x._1._1._1); }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return $InternalParameterChoiceId("IsDividedChoice", x._1._1._1._1); }
          if (x._1._1._1.tag === "Inr") { return $InternalParameterChoiceId("ScheduleChoice", x._1._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "OriginChoice") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "FulfillmentMethodChoice") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "PaymentMethodChoice") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "IsDividedChoice") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))));
    }
    if (x.tag === "ScheduleChoice") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)))); }
    $runtime.fail();
  }
};
const showInternalParameterChoiceId = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dMenu$dV2$dTypes$dOrderOrigin.showOrderOrigin.show(v)]})(OriginChoiceIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dMenu$dV2$dTypes$dFulfillmentMethod.showFulfillmentMethod.show(v)]})(FulfillmentMethodChoiceIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dMenu$dV2$dTypes$dPaymentMethod.showPaymentMethod.show(v)]})(PaymentMethodChoiceIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v ? "true" : "false"]})(IsDividedChoiceIsSymbol);
    const $4 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v ? "true" : "false"]})(ScheduleChoiceIsSymbol);
    return x => {
      const $5 = genericInternalParameterChoiceId.from(x);
      if ($5.tag === "Inl") { return $0["genericShow'"]($5._1); }
      if ($5.tag === "Inr") {
        if ($5._1.tag === "Inl") { return $1["genericShow'"]($5._1._1); }
        if ($5._1.tag === "Inr") {
          if ($5._1._1.tag === "Inl") { return $2["genericShow'"]($5._1._1._1); }
          if ($5._1._1.tag === "Inr") {
            if ($5._1._1._1.tag === "Inl") { return $3["genericShow'"]($5._1._1._1._1); }
            if ($5._1._1._1.tag === "Inr") { return $4["genericShow'"]($5._1._1._1._1); }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeInternalParameterChoiceId = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(OriginChoiceIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dOrderOrigin.unscrambleDecodeOrderOrigin.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(FulfillmentMethodChoiceIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dFulfillmentMethod.unscrambleDecodeFulfillmentMethod.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(PaymentMethodChoiceIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dPaymentMethod.unscrambleDecodePaymentMethod.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(IsDividedChoiceIsSymbol)(decodeSingleConstructorAr1))(Unscramble$dGeneric.genericDecodeSumConstruct(ScheduleChoiceIsSymbol)(decodeSingleConstructorAr1))))))(Unscramble$dGeneric.defaultOptions);
    return x => genericInternalParameterChoiceId.to($0(x));
  })()
};
const ufromJSONKeyInternalParameterChoiceId = /* #__PURE__ */ (() => (
  {fromJSONKey: Unscramble.$FromJSONKeyFunction("FromJSONKeyValue", unscrambleDecodeInternalParameterChoiceId.unsafeDecode)}
))();
const encodeInternalParameterChoiceId = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericInternalParameterChoiceId)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(OriginChoiceIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dOrderOrigin.encodeOrderOrigin.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(FulfillmentMethodChoiceIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dFulfillmentMethod.encodeFulfillmentMethod.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(PaymentMethodChoiceIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dPaymentMethod.encodePaymentMethod.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor(IsDividedChoiceIsSymbol)(genericEncodeArgsArgument);
    const $4 = Foreign$dGeneric$dClass.genericEncodeConstructor(ScheduleChoiceIsSymbol)(genericEncodeArgsArgument);
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") {
            if (v1._1._1.tag === "Inl") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1); }
            if (v1._1._1.tag === "Inr") {
              if (v1._1._1._1.tag === "Inl") { return $3.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1); }
              if (v1._1._1._1.tag === "Inr") { return $4.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1); }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const decodeInternalParameterChoiceId = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericInternalParameterChoiceId)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(OriginChoiceIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dOrderOrigin.decodeOrderOrigin.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(FulfillmentMethodChoiceIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dFulfillmentMethod.decodeFulfillmentMethod.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PaymentMethodChoiceIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dPaymentMethod.decodePaymentMethod.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(IsDividedChoiceIsSymbol)(genericDecodeArgsArgument)(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ScheduleChoiceIsSymbol)(genericDecodeArgsArgument)(Foreign$dGeneric$dClass.genericCountArgsArgument))))))
};
const asJSONKeyInternalParameterChoiceId = /* #__PURE__ */ (() => (
  {asJSONKey: Data$dMap$dSerialized.$AsJSONKeyFunction("AsJSONKeyValue", encodeInternalParameterChoiceId.encode, decodeInternalParameterChoiceId.decode)}
))();
export {
  $InternalParameterChoiceId,
  FulfillmentMethodChoice,
  FulfillmentMethodChoiceIsSymbol,
  IsDividedChoice,
  IsDividedChoiceIsSymbol,
  OriginChoice,
  OriginChoiceIsSymbol,
  PaymentMethodChoice,
  PaymentMethodChoiceIsSymbol,
  ScheduleChoice,
  ScheduleChoiceIsSymbol,
  asJSONKeyInternalParameterChoiceId,
  decodeInternalParameterChoiceId,
  decodeSingleConstructorAr1,
  encodeInternalParameterChoiceId,
  eqInternalParameterChoice,
  genericDecodeArgsArgument,
  genericEncodeArgsArgument,
  genericInternalParameterChoiceId,
  ordInternalParameterChoic,
  showInternalParameterChoiceId,
  toFillFormTypeInternalPar,
  ufromJSONKeyInternalParameterChoiceId,
  unscrambleDecodeInternalParameterChoiceId
};
